import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { Tabs } from 'antd';

import {
  withOfferSelectorReducer,
  withOfferSelectorSaga,
} from '../CustomizeOffer/withReducer';
import {
  selectAccessories,
  selectColors,
  selectAccessoriesCodes,
  selectColorCodes,
  updateFees,
} from '../CustomizeOffer/actions';
import {
  makeSelectAccessoriesSelector,
  makeSelectAccessoriesCodesSelector,
  makeSelectColorCodesSelector,
  makeSelectMonthlyRateSelector,
  makeSelectFeesVisibileSelector,
  makeSelectFeesSelector,
} from '../CustomizeOffer/selectors';
import { featureAllowed } from 'containers/App/selectors';

import { makeSelectCheckResponse } from '../PrescoringTool/selectors';

import configs from 'configs';

import messages from './messages';
import FeaturesIcon from '-!svg-react-loader!./assets/img/features.svg?name=FeaturesIcon';
import EngineIcon from '-!svg-react-loader!./assets/img/engine.svg?name=EngineIcon';
import SizesIcon from '-!svg-react-loader!./assets/img/sizes.svg?name=SizesIcon';
import ServicesIcon from '-!svg-react-loader!./assets/img/tools.svg?name=ServicesIcon';
import CarIcon from '-!svg-react-loader!./assets/img/car.svg?name=CarIcon';
import SellerIcon from '-!svg-react-loader!./assets/img/user.svg?name=SellerIcon';
import MoneyIcon from '-!svg-react-loader!./assets/img/money.svg?name=MoneyIcon';
import MoneyMoreIcon from '-!svg-react-loader!./assets/img/money-more.svg?name=MoneyMoreIcon';
import AccessoriesIcon from '-!svg-react-loader!./assets/img/option.svg?name=AccessoriesIcon';
import NotesIcon from '-!svg-react-loader!./assets/img/notes.svg?name=NotesIcon';

import { ItemBoxList, List, FeeList, PrivateNotes } from '../UIKit';
import 'antComponentsStyle';
import './styles.scss';

class OfferInfo extends React.Component {
  constructor(props) {
    super(props);
    this.serviceRef = React.createRef();
    this.techRef = React.createRef();
    this.accessoriesRef = React.createRef();
    this.notesRef = React.createRef();
    this.financeRef = React.createRef();

    this.state = {
      activeTab: this.serviceRef,
      selectedOptions: new Set(),
      selectedColor: new Set(),
    };

    this.toggle = this.toggle.bind(this);
    this.convertToGroupedList = this.convertToGroupedList.bind(this);
    this.handleOnOptionClick = this.handleOnOptionClick.bind(this);
    this.handleOnColorClick = this.handleOnColorClick.bind(this);
  }

  componentDidMount() {
    if (this.props.selectedColors && this.props.selectedColors.length) {
      this.props.selectedColors.split(',').forEach(selectedColor => {
        const colorItem = this.props.colors.find(
          color => color.description === selectedColor,
        );
        this.handleOnColorClick(colorItem.code);
      });
    }

    if (this.props.selectedOptions && this.props.selectedOptions.length) {
      this.props.selectedOptions.split(',').forEach(selectedOption => {
        setTimeout(() => {
          const optionItem = this.props.options.find(
            option => option.description === selectedOption,
          );
          this.handleOnOptionClick(optionItem.code);
        }, 100);
      });
    }
  }

  toggle = activeTab => {
    if (this.state.activeTab !== activeTab) {
      this.setState({
        activeTab,
      });
    }
  };

  convertToGroupedList(items) {
    let result = [];

    items.map(item => {
      const elem = item.description;
      const group = result.filter(e => e.group === item.group_code);
      const obj = {
        group: item.group_code,
        title: item.group,
      };
      if (Object.keys(group).length === 0) {
        obj.items = [elem];
      } else {
        const list = group[0].items;
        list.push(elem);
        obj.items = list;
        // remove all preview objects
        result = result.filter(res => res.group !== obj.group);
      }
      result.push(obj);
    });

    return result;
  }

  handleOnOptionClick(value) {
    const { selectedAccessoriesCodes, options } = this.props;
    const selectedOptions = new Set(selectedAccessoriesCodes);
    if (selectedOptions.has(value)) {
      selectedOptions.delete(value);
    } else {
      selectedOptions.add(value);
    }
    this.props.selectAccessoriesCodes([...selectedOptions]);
    const selected = options.filter(item => selectedOptions.has(item.code));
    this.props.selectAccessories(selected);
  }

  handleOnColorClick(value) {
    const { colors } = this.props;

    const selectedColors = new Set();
    selectedColors.add(value);

    this.props.selectColorCodes([...selectedColors]);
    const selected = colors.filter(item => selectedColors.has(item.code));
    this.props.selectColors(selected);
  }

  render() {
    const {
      services,
      features,
      notes,
      private_notes,
      tag,
      sizes,
      engine,
      seller,
      offerFees,
      accessories,
      equippedOptionals,
      selectMonthlyRate,
      updateFees,
      carValue,
      duration,
      deposit,
      feesVisible,
      selectedFees,
      featureAllowed,
    } = this.props;
    let { prescoringResponse } = this.props;
    prescoringResponse = prescoringResponse.hasOwnProperty('_root')
      ? prescoringResponse.toJS()
      : prescoringResponse;

    const accessoriesList = this.convertToGroupedList(accessories);
    const { monthlyRateMax, depositRequired, sustainabilityIndex, thresholdMonthlyRateMax } = prescoringResponse;

    return (
      <div id="OfferInfo" className="element-box pt-2">
        <Tabs animated={false}>
          <Tabs.TabPane
            forceRender={true}
            tab={
              <span>
                <ServicesIcon />
                <FormattedMessage {...messages.services} />
              </span>
            }
            key="1"
          >
            <ItemBoxList services={services} />
          </Tabs.TabPane>
          <Tabs.TabPane
            forceRender={true}
            tab={
              <span>
                <CarIcon />
                <FormattedMessage {...messages.carSpecs} />
              </span>
            }
            key="2"
          >
            <List
              title={messages.engine.defaultMessage}
              items={engine}
              icon={<EngineIcon />}
            />
            <List
              title={messages.sizes.defaultMessage}
              items={sizes}
              icon={<SizesIcon />}
            />
            <List
              title={messages.features.defaultMessage}
              items={features}
              icon={<FeaturesIcon />}
            />
          </Tabs.TabPane>
          {configs.accessories && accessoriesList.length > 0 ? (
            <Tabs.TabPane
              forceRender={true}
              tab={
                <span>
                  <AccessoriesIcon />
                  <FormattedMessage {...messages.accessories} />
                </span>
              }
              key="3"
            >
              {accessoriesList.map((group, key) => (
                <List key={key} title={group.title} items={group.items} />
              ))}
            </Tabs.TabPane>
          ) : null}
          {equippedOptionals && equippedOptionals.length > 0 ? (
            <Tabs.TabPane
              forceRender={true}
              tab={
                <span>
                  <AccessoriesIcon />
                  <FormattedMessage {...messages.equippedOptionals} />
                </span>
              }
              key="4"
            >
              <List title={''} items={equippedOptionals.split(',')} />
            </Tabs.TabPane>
          ) : null}
          <Tabs.TabPane
            forceRender={true}
            disabled={!notes}
            tab={
              <span className={notes ? '' : 'text-muted'}>
                <NotesIcon />
                <FormattedMessage {...messages.notes} />
              </span>
            }
            key="5"
          >
            <div dangerouslySetInnerHTML={{ __html: notes }} />
          </Tabs.TabPane>
          {(featureAllowed('fees-visibility') || configs.showRecapOfferProvider || configs.showRecapOfferProduct) &&
            <Tabs.TabPane
              forceRender={true}
              tab={
                <span>
                  <SellerIcon />
                  <FormattedMessage {...messages.seller} />
                </span>
              }
              key="6"
            >
              {(configs.showRecapOfferProvider || configs.showRecapOfferProduct) &&
                <List
                  title={messages.broker.defaultMessage}
                  items={[configs.showRecapOfferProvider && seller.broker, configs.showRecapOfferProduct && seller.product]}
                  icon={<FeaturesIcon />}
                />
              }
              {tag && tag === 'Catalogo' ? (
                <PrivateNotes
                  title={messages.private_notes.defaultMessage}
                  icon={<NotesIcon />}
                  text={private_notes}
                />
              ) : (
                featureAllowed('fees-visibility') && feesVisible && selectMonthlyRate > 0 &&
                <FeeList
                  title={messages.fee.defaultMessage}
                  item={seller.commission}
                  has_over_commission={seller.has_over_commission}
                  has_under_commission={seller.has_under_commission}
                  has_extra_commission={seller.has_extra_commission}
                  offerFees={offerFees}
                  selectedFees={selectedFees}
                  carValue={carValue}
                  duration={duration}
                  icon={<MoneyIcon />}
                  iconExtra={<MoneyMoreIcon />}
                  monthlyRate={selectMonthlyRate}
                  monthlyRateMax={monthlyRateMax > 0 ? monthlyRateMax : null}
                  depositRequired={depositRequired > 0 ? depositRequired : null}
                  thresholdMonthlyRateMax={thresholdMonthlyRateMax > 0 ? thresholdMonthlyRateMax : null}
                  deposit={deposit > 0 ? deposit : null}
                  sustainabilityIndex={sustainabilityIndex}
                  onUpdateFees={updateFees}
                />
              )}
            </Tabs.TabPane>
          }
        </Tabs>
      </div>
    );
  }
}

OfferInfo.propTypes = {
  services: PropTypes.array.isRequired,
  sizes: PropTypes.array.isRequired,
  engine: PropTypes.array.isRequired,
  features: PropTypes.array.isRequired,
  seller: PropTypes.object.isRequired,
  carValue: PropTypes.number,
  offerFees: PropTypes.any,
  duration: PropTypes.number.isRequired,
  deposit: PropTypes.any,
  accessories: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    selectAccessories: accessories => dispatch(selectAccessories(accessories)),
    selectColors: colors => dispatch(selectColors(colors)),
    selectAccessoriesCodes: codes => dispatch(selectAccessoriesCodes(codes)),
    selectColorCodes: codes => dispatch(selectColorCodes(codes)),
    updateFees: fees => dispatch(updateFees(fees)),
  };
}
const mapStateToProps = createStructuredSelector({
  selectedAccessories: makeSelectAccessoriesSelector(),
  selectedAccessoriesCodes: makeSelectAccessoriesCodesSelector(),
  selectedColorCodes: makeSelectColorCodesSelector(),
  selectMonthlyRate: makeSelectMonthlyRateSelector(),
  feesVisible: makeSelectFeesVisibileSelector(),
  selectedFees: makeSelectFeesSelector(),
  prescoringResponse: makeSelectCheckResponse(),
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withOfferSelectorReducer,
  withOfferSelectorSaga,
  withConnect,
)(OfferInfo);
